<div class="container iep-form-container">
  <div class="row">
    <div class="col-lg-12" style="padding-left: 0px; padding-right: 0px">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 id="heading" style="margin-bottom: 3px; margin-top: 5px">
            <span>{{ 'export.realTime.title' | translate }}</span>
            <button
              class="info-box"
              matTooltip="{{ 'export.realTime.info' | translate }}"
              matTooltipShowDelay="500"
              matTooltipPosition="right"
              aria-label="Button that displays a tooltip when focused or hovered over"
            >
              i
            </button>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <!-- Export Realtime Data Form -->
              <form
                name="form"
                [formGroup]="formRealtimeData"
                (ngSubmit)="submitRealtimeDataForm()"
                #formDirective="ngForm"
              >
                <!-- Select Site if mutiple site is true -->
                <div class="row" *ngIf="displayAllSiteID">
                  <div class="col-lg-1"></div>
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    <mat-label class="label-input"
                      >{{ 'export.selectSite' | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field>
                      <mat-label>{{
                        'export.sitePlaceholder' | translate
                      }}</mat-label>
                      <mat-select
                        id="siteId"
                        formControlName="siteCtr"
                        name="siteID"
                        [(ngModel)]="siteId"
                        (ngModelChange)="getAllMetersforSiteId($event)"
                        required
                      >
                        <mat-option
                          *ngFor="let item of sites"
                          value="{{ item.siteId }}"
                        >
                          {{ item.siteName }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('siteCtr', 'required')"
                        >{{ 'export.errorRequired' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <!-- Fetch & display SiteId if mutiple site is false -->
                <div
                  class="row"
                  style="margin-top: 1px; margin-bottom: 15px"
                  *ngIf="!displayAllSiteID"
                >
                  <div class="col-lg-1"></div>
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    <mat-label style="margin-bottom: 3px">{{
                      'export.siteID' | translate
                    }}</mat-label>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    {{ siteId }}
                  </div>
                </div>

                <!-- Choose Load -->
                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    <mat-label class="label-input"
                      >{{ 'export.chooseLoad' | translate }}
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-form-field>
                      <mat-select
                        [(ngModel)]="loadId"
                        name="load"
                        formControlName="loadCtr"
                        placeholder="{{ 'export.loadPlaceholder' | translate }}"
                        required
                      >
                        <mat-option
                          *ngFor="let load of loadDataOfSites"
                          value="{{ load.meterId }}"
                          >{{ load.loadName }} ----
                          {{ load.meterId }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('loadCtr', 'required')"
                        >{{ 'export.errorRequired' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <!-- Select Date Range -->
                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-md-3">
                    <mat-label class="label-input"
                      >{{ 'export.selectDate' | translate }}
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-3">
                    <mat-form-field style="width: 200px">
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        [formControl]="startDateCtr"
                        placeholder="{{ 'export.fromDate' | translate }}"
                        (dateChange)="validateStartDate()"
                        [max]="max"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker1"
                      ></mat-datepicker-toggle>
                      <mat-datepicker
                        #picker1
                        startView="month"
                        (yearSelected)="chosenStartDate_YearHandler($event)"
                        (monthSelected)="chosenStartDate_MonthHandler($event)"
                      ></mat-datepicker>
                      <mat-error
                        *ngIf="startDateCtr.invalid || !isValidStartDate"
                        >{{ startDateErrorMessage }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field style="width: 200px">
                      <input
                        matInput
                        [matDatepicker]="picker2"
                        [formControl]="endDateCtr"
                        placeholder="{{ 'export.toDate' | translate }}"
                        (dateChange)="validateEndDate()"
                        [max]="max"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker2"
                      ></mat-datepicker-toggle>
                      <mat-datepicker
                        #picker2
                        startView="month"
                        (yearSelected)="chosenEndDate_YearHandler($event)"
                        (monthSelected)="chosenEndDate_MonthHandler($event)"
                      ></mat-datepicker>
                      <mat-error
                        *ngIf="endDateCtr.invalid || !isValidEndDate"
                        >{{ endDateErrorMessage }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <!-- Submit & clear buttons -->
                <div class="row btn-panel">
                  <div class="col-md-8 pull-right">
                    <button
                      bciprimarybutton
                      class="button-primary"
                      (click)="goToBack()"
                      type="button"
                      id="back-btn"
                    >
                      {{ 'export.back' | translate }}
                    </button>
                    &nbsp;

                    <!-- Submit button to export realtime data -->
                    <button
                      bciprimarybutton
                      class="button-primary"
                      type="submit"
                      id="submitRealtimeDataForm"
                      [disabled]="
                        startDateCtr.invalid ||
                        endDateCtr.invalid ||
                        !formRealtimeData.valid
                      "
                    >
                      <span>
                        <mat-icon
                          aria-hidden="false"
                          aria-label="weather icon"
                          class="bosch-ic-checkmark-frame"
                          style="width: max-content"
                        >
                        </mat-icon>
                      </span>
                      {{ 'export.submit' | translate }}
                    </button>
                    <!-- Clear all fields of form -->
                    &nbsp;
                    <button
                      id="resetbtn"
                      bciprimarybutton
                      class="button-primary"
                      (click)="reset($event)"
                    >
                      <span>
                        <mat-icon
                          aria-hidden="false"
                          aria-label="weather icon"
                          class="bosch-ic-reset"
                          style="width: max-content"
                        ></mat-icon>
                      </span>
                      {{ 'export.reset' | translate }}
                    </button>
                  </div>
                </div>
              </form>
              <!-- Form Close -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
